import React from 'react'

const UserDetailReportIcon = (props) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M29.3334 10.4127V21.586C29.3334 25.3327 27.6134 27.906 24.5867 28.8793C23.7068 29.186 22.6934 29.3327 21.5868 29.3327H10.4134C9.30674 29.3327 8.29341 29.186 7.41341 28.8793C4.38674 27.906 2.66675 25.3327 2.66675 21.586V10.4127C2.66675 5.55935 5.56008 2.66602 10.4134 2.66602H21.5868C26.4401 2.66602 29.3334 5.55935 29.3334 10.4127Z" fill="#0057FF" />
            <path d="M24.5867 28.8803C23.7067 29.187 22.6933 29.3337 21.5867 29.3337H10.4133C9.30666 29.3337 8.29333 29.187 7.41333 28.8803C7.88 25.3603 11.56 22.627 16 22.627C20.44 22.627 24.12 25.3603 24.5867 28.8803Z" fill="#0057FF" />
            <path d="M20.7732 15.4394C20.7732 18.0794 18.6399 20.226 15.9999 20.226C13.3599 20.226 11.2266 18.0794 11.2266 15.4394C11.2266 12.7994 13.3599 10.666 15.9999 10.666C18.6399 10.666 20.7732 12.7994 20.7732 15.4394Z" fill="#0057FF" />
        </svg>

    )
}

export default UserDetailReportIcon